/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Expectlist_Allmoviesstrong3Inputs */

const id_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua 9 Film`)
};

const ms_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua 9 Filem`)
};

const da_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle 9 Film`)
};

const de_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle 9 Filme`)
};

const en_us2_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All 9 Movies`)
};

const es_es2_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las 9 películas`)
};

const es_mx2_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las 9 películas`)
};

const fil_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng 9 na Pelikula`)
};

const fr_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les 9 films`)
};

const it_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti e 9 i film`)
};

const hu_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mind a 9 film`)
};

const nl_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle 9 films`)
};

const no_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle 9 filmene`)
};

const pl_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie 9 filmów`)
};

const pt_br2_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os 9 filmes`)
};

const pt_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os 9 filmes`)
};

const ro_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate cele 9 filme`)
};

const fi_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki 9 elokuvaa`)
};

const sv_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla 9 filmer`)
};

const vi_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả 9 bộ phim`)
};

const tr_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 Filmin Tamamı`)
};

const cs_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všech 9 filmů`)
};

const bg_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всичките 9 филма`)
};

const ru_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все 9 фильмов`)
};

const uk_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі 9 фільмів`)
};

const ar_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الأفلام التسعة`)
};

const hi_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी 9 फ़िल्में`)
};

const th_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพยนตร์ทั้ง 9 เรื่อง`)
};

const ja_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全9作品`)
};

const zh_cn2_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部9部电影`)
};

const zh_hant1_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部9部電影`)
};

const ko_misc_posts_expectlist_allmoviesstrong3 = /** @type {(inputs: Misc_Posts_Expectlist_Allmoviesstrong3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 9개 영화`)
};

/**
* | output |
* | --- |
* | "All 9 Movies" |
*
* @param {Misc_Posts_Expectlist_Allmoviesstrong3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_allmoviesstrong3 = /** @type {((inputs?: Misc_Posts_Expectlist_Allmoviesstrong3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Allmoviesstrong3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "da") return da_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "de") return de_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "it") return it_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "no") return no_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "th") return th_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_allmoviesstrong3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_allmoviesstrong3(inputs)
	return ko_misc_posts_expectlist_allmoviesstrong3(inputs)
});
export { misc_posts_expectlist_allmoviesstrong3 as "misc.posts.expectList.allMoviesStrong" }